import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import Icon from 'components/blocks/Icon/Icon';
import useDecode from 'hooks/useDecode';
import useGetRoyalDecreeFormsCount from 'hooks/useGetRoyalDecreeFormsCount';
import './InfoRoyalDecreeFormNew.scss';

interface IAlert {
  id: string;
  level: 'warn' | 'info';
  icon: string;
  date: string;
  tag?: string;
  title: string;
  body: string;
  cta: string;
}

interface InfoRoyalDecreeFormNewProps {
  onNav?: (section: string) => void;
}

const InfoRoyalDecreeFormNew: React.FC<InfoRoyalDecreeFormNewProps> = ({ onNav }) => {
  const { getRoyalDecreeFormsCount, royalDecreeFormsCount } = useGetRoyalDecreeFormsCount();
  const navigate = useNavigate();
  const tokenResponse = useDecode('token');
  const userId = tokenResponse?.extension_id;

  const [alerts, setAlerts] = useState<IAlert[]>([]);

  useEffect(() => {
    if (userId) getRoyalDecreeFormsCount(userId);
  }, [userId]);

  useEffect(() => {
    if (royalDecreeFormsCount && royalDecreeFormsCount.Cantidad >= 0) {
      const tipo = royalDecreeFormsCount.Tipo;
      const date = new Date().toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
      if (Number(tipo) === 34) {
        setAlerts([
          {
            id: 'royal-decree-incendios',
            level: 'warn',
            icon: 'fire',
            date,
            /*tag: 'RD INCENDIOS',*/
            title: 'Solicitud de Prestación por Cese de Actividad Fuerza Mayor Incendio',
            body: 'Ya tiene a su disposición el formulario para solicitar esta nueva prestación.',
            cta: 'Acceder al formulario',
          },
        ]);
        return;
      }

      /* setAlerts([
        {
          id: 'royal-decree-1',
          level: 'warn',
          icon: 'alert-triangle',
          date,
          tag: `Auditoría ${tipo ?? ''}`.trim(),
          title: `Auditoría Prestación Extraordinaria${tipo ? ' ' + tipo : ''}`,
          body: `Ya tiene a su disposición, en el apartado de <strong>Notificaciones</strong>, el formulario de la Auditoría${tipo ? ' ' + tipo : ''} donde le indicamos la documentación que nos debe remitir.`,
          cta: 'Acceder al formulario',
        },
      ]); */
    }
  }, [royalDecreeFormsCount]);

  if (alerts.length === 0) {
    return null;
  }

  const handleAlertAction = () => {
    if (alerts[0]?.id === 'royal-decree-incendios') {
      navigate('/mis-gestiones/formularios?id=34&origen=2', {
        state: {
          id: 34,
          origen: 2,
          titulo: alerts[0]?.title,
        },
      });
      return;
    }

    onNav && onNav('notificaciones');
  };

  return (
    <section className="alerts-section" data-screen-label="home-alerts">
      <div className="container">
        <div className="alerts-section__head">
          <div className="alerts-section__heading">
            <span className="alerts-section__badge" aria-hidden>
              <Icon name="bell" size={16} />
              <span>{alerts.length}</span>
            </span>
            <div>
              <h2 className="alerts-section__title">Avisos importantes</h2>
              <p className="alerts-section__sub">
                Avisos que requieren tu atención. No los pierdas de vista.
              </p>
            </div>
          </div>
          {/*  <a
            className="alerts-section__all"
            href="#"
            onClick={(e) => { e.preventDefault(); onNav && onNav('notificaciones'); }}
          >
            Ver todas las notificaciones <Icon name="arrow-right" size={16} />
          </a> */}
        </div>

        <div
          className={'alert-feature alert-feature--' + alerts[0].level + ' reveal is-in'}
          role="region"
          aria-label="Aviso principal"
        >
          <aside className="alert-feature__side" aria-hidden>
            <div className="alert-feature__glyph">
              <Icon name={alerts[0].icon} size={alerts[0].icon === 'fire' ? 144 : 56} />
            </div>
            <div className="alert-feature__date">
              <div className="alert-feature__date-day">{alerts[0].date.split(' ')[0]}</div>
              <div className="alert-feature__date-mon">{alerts[0].date.split(' ').slice(1).join(' ')}</div>
            </div>
          </aside>
          <div className="alert-feature__main">
            <h3 className="alert-feature__title">{alerts[0].title}</h3>
            <p className="alert-feature__body" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(alerts[0].body) }} />
            <div className="alert-feature__actions">
              <button className="btn btn--primary" onClick={handleAlertAction}>
                {alerts[0].cta} <Icon name="arrow-right" size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoRoyalDecreeFormNew;
